import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addLinkType: {
		id: 'portfolio-3-dependency-settings.ui.dependency-list.add-link-type',
		defaultMessage: 'Add link type...',
		description: "Placeholder for the select when it's for adding a new dependency.",
	},
});
